import React from 'react';
import DefaultHeader from '../Layout/DefaultHeader';
import Navbar1 from '../Layout/Navbar1';
import {getCart} from '../Cart/CartHelpers'
// import { isAuthenticated } from '../../auth/authenticate';
// import { Link } from 'react-router-dom';
function Checkout(props) {
  // const userId = isAuthenticated() && isAuthenticated().data.user._id||isAuthenticated()&&isAuthenticated()._id;
  // const token = isAuthenticated() && isAuthenticated().data.user.token||isAuthenticated()&&isAuthenticated().token;;
    return (
        <React.Fragment>
            <Navbar1/>
            <DefaultHeader/>
            <main className="mt-2">
    <div className="container wow fadeIn">
      <h2 className="h2 text-center">THANH TOÁN</h2>
      <div className="row">
        <div className="col-md-8 mb-4">
          <div className="card">
            <form className="card-body">

              <div className="md-form pl-0 mb-5">
              <label forHtml="username" className="">Họ và tên *</label>
                <input type="text"id="username" placeholder="Họ và tên" className="form-control py-0" aria-describedby="basic-addon1"/>
              </div>

              {/* <!--email--> */}
              <div className="md-form mb-5">
                <label for="email" className="">Địa chỉ email (Không bắt buộc)</label>
                <input type="text" id="email" className="form-control" placeholder="youremail@example.com"/>
              </div>

              {/* <!--address--> */}
              <div className="md-form mb-5">
                <label for="address" className="">Địa chỉ *</label>
                <input type="text" id="address" className="form-control" placeholder="Địa chỉ nhà, căn hộ, toà nhà,.."/>
              </div>

              {/* <!--Grid row--> */}
              <div className="row">

                {/* <!--Grid column--> */}
                <div className="col-lg-4 col-md-12 mb-4">

                  <label for="country">Tỉnh/Thành phố *</label>
                  <select className="custom-select d-block w-100" id="country" required>
                    <option value="">Choose...</option>
                    <option>Ho Chi Minh</option>
                  </select>
                  <div className="invalid-feedback">
                    Please select a valid country.
                  </div>

                </div>
                {/* <!--Grid column--> */}

                <div className="col-lg-4 col-md-6 mb-4">

                  <label for="state">Quận/Huyện *</label>
                  <select className="custom-select d-block w-100" id="state" required>
                    <option value="">Choose...</option>
                    <option>Q.3</option>
                  </select>
                  <div className="invalid-feedback">
                    Please provide a valid state.
                  </div>

                </div>
                <div className="col-lg-4 col-md-6 mb-4">

                <label for="state">Phường/Xã *</label>
                <select className="custom-select d-block w-100" id="state" required>
                <option value="">Choose...</option>
                <option>Hoang Sa</option>
                </select>
                <div className="invalid-feedback">
                Please provide a valid state.
                </div>

                </div>
                {/* <!--Grid column--> */}
              </div>
              {/* <!--Grid row--> */}

              <hr/>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="same-address"/>
                <label className="custom-control-label" for="same-address">Lấy hoá đơn VAT (Không bắt buộc)</label>
              </div>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="save-info"/>
                <label className="custom-control-label" for="save-info">Gọi trước khi giao (Không bắt buộc)</label>
              </div>

              <hr/>
              <div className="md-form pl-0 mb-5">
              <label forHtml="note" className="">Order Notes (Không bắt buộc)</label>
                <textarea type="text"id="note" placeholder="Order Notes..." className="form-control py-0" aria-describedby="basic-addon1" rows="5"></textarea>
              </div>

              {/* <div className="d-block my-3">
                <div className="custom-control custom-radio">
                  <input id="credit" name="paymentMethod" type="radio" className="custom-control-input" checked required/>
                  <label className="custom-control-label" for="credit">Credit card</label>
                </div>
                <div className="custom-control custom-radio">
                  <input id="debit" name="paymentMethod" type="radio" className="custom-control-input" required/>
                  <label className="custom-control-label" for="debit">Debit card</label>
                </div>
                <div className="custom-control custom-radio">
                  <input id="paypal" name="paymentMethod" type="radio" className="custom-control-input" required/>
                  <label className="custom-control-label" for="paypal">Paypal</label>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label for="cc-name">Name on card</label>
                  <input type="text" className="form-control" id="cc-name" placeholder="" required/>
                  <small className="text-muted">Full name as displayed on card</small>
                  <div className="invalid-feedback">
                    Name on card is required
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label for="cc-number">Credit card number</label>
                  <input type="text" className="form-control" id="cc-number" placeholder="" required/>
                  <div className="invalid-feedback">
                    Credit card number is required
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label for="cc-expiration">Expiration</label>
                  <input type="text" className="form-control" id="cc-expiration" placeholder="" required/>
                  <div className="invalid-feedback">
                    Expiration date required
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <label for="cc-expiration">CVV</label>
                  <input type="text" className="form-control" id="cc-cvv" placeholder="" required/>
                  <div className="invalid-feedback">
                    Security code required
                  </div>
                </div>
              </div> */}

            </form>

          </div>
          {/* <!--/.Card--> */}

        </div>
        {/* <!--Grid column--> */}

        {/* <!--Grid column--> */}
        <div className="col-md-4 mb-4">

          {/* <!-- Heading --> */}
          <h4 className="d-flex justify-content-between align-items-center mb-3">
            <span className="text-muted">ĐƠN HÀNG CỦA BẠN</span>
            <span className="badge badge-secondary badge-pill">{getCart().length}</span>
          </h4>

          {/* <!-- Cart --> */}
          <ul className="list-group mb-3 z-depth-1">
              {getCart().map(pro=>(
            <li key={pro._id} className="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 className="my-0">{pro.name}</h6>
              <small className="text-muted">{"x "+pro.count}</small>
              </div>
              <span className="text-muted">{pro.price*pro.count+",000VND"}</span>
            </li>

              ))}

            <li className="list-group-item d-flex justify-content-between bg-light">
              <div className="text-success">
                <h6 className="my-0">Giảm giá</h6>
              </div>
              <span className="text-success">-0VND</span>
            </li>
            <li className="list-group-item d-flex justify-content-between">
              <span>Tổng tiền</span>
        <strong>{getCart().map(pro=>(pro.count*pro.price)).reduce((total,cur)=>total+cur)+",000VND"}</strong>
            </li>
          </ul>
          {/* <!-- Cart --> */}

          {/* <!-- Promo code --> */}
          <form className="card mb-4 p-2">
            <div className="input-group">
              <input type="text" className="form-control" placeholder="Mã giảm giá" aria-label="Recipient's username" aria-describedby="basic-addon2"/>
              <div className="input-group-append">
                <button className="btn btn-secondary btn-md waves-effect m-0" type="button">Xác nhận</button>
              </div>
            </div>
          </form>
          {/* <!-- Promo code --> */}
          <div className="card p-2 ">

          <p>Thanh toán tiền mặt</p>
            <p>Thanh toán bằng tiền mặt khi giao hàng</p>
            <button className="btn btn-primary btn-lg btn-block" type="submit">ĐẶT HÀNG</button>
          </div>
          

        </div>
        {/* <!--Grid column--> */}

      </div>
      {/* <!--Grid row--> */}

    </div>
  </main>
        </React.Fragment>
        
    );
}

export default Checkout;